import React from 'react';

import ErrorPopUp from 'components/ErrorPopUp';

export function ErrorFallback() {
    return <ErrorPopUp />;
}

export { default } from './ErrorBoundary';
